export default __webpack_public_path__ + "static/media/Trade_Gothic_LT.9efed080.ttf";